var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMrfRoadmapLap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2701.859,
    height: 755.529,
    viewBox: "0 0 2701.859 755.529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_7382",
    "data-name": "Group 7382",
    transform: "translate(-9102.771 -1192)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    x2: 2694.6,
    transform: "translate(9106.4 1579.079)",
    fill: "none",
    stroke: "#d8d8d8",
    strokeLinecap: "round",
    strokeWidth: 7.259
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-18",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(10505.601 1566.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-7",
    y1: 370.5,
    transform: "translate(10519.1 1574.579)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-7",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(10510.6 1571.279)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Biographical_information_for",
    "data-name": "Biographical information for",
    transform: "translate(10549.056 1654.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Biographical information for")), /*#__PURE__*/React.createElement("text", {
    id: "Family_Members_and_Pets.",
    "data-name": "Family Members and Pets.",
    transform: "translate(10549.056 1686.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Family Members and Pets.")), /*#__PURE__*/React.createElement("text", {
    id: "Who_are_the_Pallberears_What_is_your",
    "data-name": "Who are the Pallberears? What is your",
    transform: "translate(10549.056 1732.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Who are the Pallberears? What is your")), /*#__PURE__*/React.createElement("text", {
    id: "spouses_complete_military_record_Who",
    "data-name": "spouses complete military record? Who",
    transform: "translate(10549.056 1762.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "spouses complete military record? Who")), /*#__PURE__*/React.createElement("text", {
    id: "do_you_notify_in_case_of_Death_When_did",
    "data-name": "do you notify in case of Death? When did",
    transform: "translate(10549.056 1792.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "do you notify in case of Death? When did")), /*#__PURE__*/React.createElement("text", {
    id: "they_graduate_college_What_is_your_Pets",
    "data-name": "they graduate college? What is your Pets",
    transform: "translate(10549.056 1822.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "they graduate college? What is your Pets")), /*#__PURE__*/React.createElement("text", {
    id: "Microchip_number_What_is_the_name_of",
    "data-name": "Microchip number? What is the name of",
    transform: "translate(10549.056 1852.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Microchip number? What is the name of")), /*#__PURE__*/React.createElement("text", {
    id: "your_pets_medication_What_special_diet",
    "data-name": "your pets medication? What special diet",
    transform: "translate(10549.056 1882.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "your pets medication? What special diet")), /*#__PURE__*/React.createElement("text", {
    id: "is_your_pet_on_It_s_all_saved_here_on_your",
    "data-name": "is your pet on? It\\u2019s all saved here on your",
    transform: "translate(10549.056 1912.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "is your pet on? It\u2019s all saved here on your")), /*#__PURE__*/React.createElement("text", {
    id: "MYREDFOLDER_Plan.",
    "data-name": "MYREDFOLDER\\xAE Plan.",
    transform: "translate(10549.056 1942.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MYREDFOLDER\xAE Plan.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-19",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(10686.896 1565.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-8",
    x2: 366.8,
    transform: "translate(10700.426 1217) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-8",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(10708.926 1570.1) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "What_about_Grandma_s_Medicine:",
    "data-name": "What about Grandma\\u2019s Medicine:",
    transform: "translate(10730.502 1245.278)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "What about Grandma\u2019s Medicine:")), /*#__PURE__*/React.createElement("text", {
    id: "During_a_major_disaster_scenario_it_is_quite_likely_that",
    "data-name": "During a major disaster scenario it is quite likely that",
    transform: "translate(10730.502 1283.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "During a major disaster scenario it is quite likely that")), /*#__PURE__*/React.createElement("text", {
    id: "an_evacuation_will_happen_very_quickly_and_without",
    "data-name": "an evacuation will happen very quickly and without",
    transform: "translate(10730.502 1313.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "an evacuation will happen very quickly and without")), /*#__PURE__*/React.createElement("text", {
    id: "time_to_plan._Many_times_prescription_information_or",
    "data-name": "time to plan. Many times prescription information, or",
    transform: "translate(10730.502 1343.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "time to plan. Many times prescription information, or")), /*#__PURE__*/React.createElement("text", {
    id: "other_medical_information_is_left_behind._Your",
    "data-name": "other medical information is left behind. Your",
    transform: "translate(10730.502 1373.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "other medical information is left behind. Your")), /*#__PURE__*/React.createElement("text", {
    id: "MYREDFOLDER_plan_prevents_this_from_happening",
    "data-name": "MYREDFOLDER\\xAE plan prevents this from happening",
    transform: "translate(10730.502 1403.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MYREDFOLDER\xAE plan prevents this from happening")), /*#__PURE__*/React.createElement("text", {
    id: "as_you_will_have_immediate_access_to_medications",
    "data-name": "as you will have immediate access to medications",
    transform: "translate(10730.502 1433.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "as you will have immediate access to medications")), /*#__PURE__*/React.createElement("text", {
    id: "and_or_medical_conditions_for_family_members_as_well",
    "data-name": "and/or medical conditions for family members as well",
    transform: "translate(10730.502 1463.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and/or medical conditions for family members as well")), /*#__PURE__*/React.createElement("text", {
    id: "as_pets._The_ability_to_have_this_information_readily",
    "data-name": "as pets. The ability to have this information readily",
    transform: "translate(10730.502 1493.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "as pets. The ability to have this information readily")), /*#__PURE__*/React.createElement("text", {
    id: "available_for_the_pharmacy_is_critical.",
    "data-name": "available for the pharmacy is critical.",
    transform: "translate(10730.502 1523.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "available for the pharmacy is critical.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-20",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(10968.896 1566.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-9",
    y1: 334.5,
    transform: "translate(10982.426 1574.529)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-9",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(10973.926 1571.229)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Digital_structural_analysis",
    "data-name": "Digital structural analysis",
    transform: "translate(11012.535 1654.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Digital structural analysis")), /*#__PURE__*/React.createElement("text", {
    id: "report_and_post-disaster",
    "data-name": "report and post-disaster",
    transform: "translate(11012.535 1686.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "report and post-disaster")), /*#__PURE__*/React.createElement("text", {
    id: "assessment_forms.",
    "data-name": "assessment forms.",
    transform: "translate(11012.535 1718.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "assessment forms.")), /*#__PURE__*/React.createElement("text", {
    id: "Your_insurance_agent_will_love_you._The",
    "data-name": "Your insurance agent will love you. The",
    transform: "translate(11012.535 1755.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Your insurance agent will love you. The")), /*#__PURE__*/React.createElement("text", {
    id: "structual_analysis_report_is_like_an",
    "data-name": "structual analysis report is like an",
    transform: "translate(11012.535 1785.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "structual analysis report is like an")), /*#__PURE__*/React.createElement("text", {
    id: "appraisal_for_a_DISASTER._The_Structural",
    "data-name": "appraisal for a DISASTER. The Structural",
    transform: "translate(11012.535 1815.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "appraisal for a DISASTER. The Structural")), /*#__PURE__*/React.createElement("text", {
    id: "analysis_report_allows_you_to_record_all",
    "data-name": "analysis report allows you to record all",
    transform: "translate(11012.535 1845.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "analysis report allows you to record all")), /*#__PURE__*/React.createElement("text", {
    id: "damages_in_an_organized_fashion.",
    "data-name": "damages in an organized fashion.",
    transform: "translate(11012.535 1875.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "damages in an organized fashion.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-21",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(11267.904 1565.079)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-10",
    x2: 299.8,
    transform: "translate(11281.443 1283.999) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-10",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(11289.943 1570.099) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Store_your_Passports_",
    "data-name": "Store your Passports,",
    transform: "translate(11311.931 1298.278)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Store your Passports,")), /*#__PURE__*/React.createElement("text", {
    id: "Drivers_License_and",
    "data-name": "Drivers License, and",
    transform: "translate(11311.931 1330.278)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Drivers License, and")), /*#__PURE__*/React.createElement("text", {
    id: "Other_ID_s.",
    "data-name": "Other ID\\u2019s.",
    transform: "translate(11311.931 1362.278)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Other ID\u2019s.")), /*#__PURE__*/React.createElement("text", {
    id: "Don_t_get_stuck_in_another_Country",
    "data-name": "Don\\u2019t get stuck in another Country",
    transform: "translate(11311.931 1398.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Don\u2019t get stuck in another Country")), /*#__PURE__*/React.createElement("text", {
    id: "without_verification_of_your_lost_or",
    "data-name": "without verification of your lost or",
    transform: "translate(11311.931 1428.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "without verification of your lost or")), /*#__PURE__*/React.createElement("text", {
    id: "stolen_documents._Nothing_to",
    "data-name": "stolen documents. Nothing to",
    transform: "translate(11311.931 1458.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "stolen documents. Nothing to")), /*#__PURE__*/React.createElement("text", {
    id: "worry_about:_its_all_part_of_your",
    "data-name": "worry about: its all part of your",
    transform: "translate(11311.931 1488.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "worry about: its all part of your")), /*#__PURE__*/React.createElement("text", {
    id: "MYREDFOLDER_Plan",
    "data-name": "MYREDFOLDER\\xAE Plan",
    transform: "translate(11311.931 1518.265)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "MYREDFOLDER\xAE Plan")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-22",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(11419.602 1566.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-11",
    y1: 224.5,
    transform: "translate(11433.143 1574.529)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-11",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(11424.643 1571.229)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "The_MYREDFOLDER_Plan",
    "data-name": "The MYREDFOLDER\\xAE Plan",
    transform: "translate(11462.984 1654.53)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "The MYREDFOLDER\xAE Plan")), /*#__PURE__*/React.createElement("text", {
    id: "and_APP_represent_only_two",
    "data-name": "and APP represent only two",
    transform: "translate(11462.984 1686.53)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and APP represent only two")), /*#__PURE__*/React.createElement("text", {
    id: "of_our_many_world_class",
    "data-name": "of our many world class",
    transform: "translate(11462.984 1718.53)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of our many world class")), /*#__PURE__*/React.createElement("text", {
    id: "products_and_services_that",
    "data-name": "products and services that",
    transform: "translate(11462.984 1750.53)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "products and services that")), /*#__PURE__*/React.createElement("text", {
    id: "our_company_provides.",
    "data-name": "our company provides.",
    transform: "translate(11462.984 1782.53)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "our company provides.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-12",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(9161 1566.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    x1: 359.5,
    transform: "translate(9174.55 1574.579) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(9183.05 1571.279) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "The_Ultimate_Family_Disaster_Plan",
    "data-name": "The Ultimate Family Disaster Plan",
    transform: "translate(9204.035 1654.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "The Ultimate Family Disaster Plan")), /*#__PURE__*/React.createElement("text", {
    id: "You_can_t_put_a_price_on_this._A_disaster_can_happen_at",
    "data-name": "You can\\u2019t put a price on this. A disaster can happen at",
    transform: "translate(9204.035 1690.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "You can\u2019t put a price on this. A disaster can happen at")), /*#__PURE__*/React.createElement("text", {
    id: "any_time_including_years_after_the_plan_is_developed_",
    "data-name": "any time including years after the plan is developed,",
    transform: "translate(9204.035 1720.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "any time including years after the plan is developed,")), /*#__PURE__*/React.createElement("text", {
    id: "but_having_access_to_your_plan_will_ensure_that",
    "data-name": "but having access to your plan will ensure that",
    transform: "translate(9204.035 1750.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "but having access to your plan will ensure that")), /*#__PURE__*/React.createElement("text", {
    id: "everyone_knows_where_to_meet_whether_in-town_or_out-",
    "data-name": "everyone knows where to meet whether in-town or out-",
    transform: "translate(9204.035 1780.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "everyone knows where to meet whether in-town or out-")), /*#__PURE__*/React.createElement("text", {
    id: "of-town_based_on_the_meeting_locations_you_set_PRE-",
    "data-name": "of-town based on the meeting locations you set PRE-",
    transform: "translate(9204.035 1810.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of-town based on the meeting locations you set PRE-")), /*#__PURE__*/React.createElement("text", {
    id: "DISASTER_Locked-in_via_Google_Maps_._They_simply",
    "data-name": "DISASTER (Locked-in via Google Maps). They simply",
    transform: "translate(9204.035 1840.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DISASTER (Locked-in via Google Maps). They simply")), /*#__PURE__*/React.createElement("text", {
    id: "log_on_to_the_plan_via_their_smart_phone_or_tablet_and",
    "data-name": "log on to the plan via their smart phone or tablet, and",
    transform: "translate(9204.035 1870.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "log on to the plan via their smart phone or tablet, and")), /*#__PURE__*/React.createElement("text", {
    id: "view_the_different_meeting_locations_and_other",
    "data-name": "view the different meeting locations and other",
    transform: "translate(9204.035 1900.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "view the different meeting locations and other")), /*#__PURE__*/React.createElement("text", {
    id: "important_instructions.",
    "data-name": "important instructions.",
    transform: "translate(9204.035 1930.529)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "important instructions.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-13",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(9242.196 1565.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-2",
    x2: 391.8,
    transform: "translate(9255.716 1192) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-2",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(9264.216 1570.1) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "It_comes_with_a_MYREDFOLDER_App_",
    "data-name": "It comes with a MYREDFOLDER\\xAE App!",
    transform: "translate(9285.701 1215.279)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "It comes with a MYREDFOLDER\xAE App!")), /*#__PURE__*/React.createElement("text", {
    id: "This_App_gives_the_App_owner_the_ability_to_locate_and",
    "data-name": "This App gives the App owner the ability to locate and",
    transform: "translate(9285.701 1251.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "This App gives the App owner the ability to locate and")), /*#__PURE__*/React.createElement("text", {
    id: "track_ALL_family_members_in_the_event_of_a_Disaster_as",
    "data-name": "track ALL family members in the event of a Disaster as",
    transform: "translate(9285.701 1281.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "track ALL family members in the event of a Disaster as")), /*#__PURE__*/React.createElement("text", {
    id: "well_as_to_send_PRE-WRITTEN_messages_to",
    "data-name": "well as to send \\u201CPRE-WRITTEN\\u201D messages to",
    transform: "translate(9285.701 1311.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "well as to send \u201CPRE-WRITTEN\u201D messages to")), /*#__PURE__*/React.createElement("text", {
    id: "everyone_s_phone_with_the_press_of_a_button._It_is_likely",
    "data-name": "everyone\\u2019s phone with the press of a button. It is likely",
    transform: "translate(9285.701 1341.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "everyone\u2019s phone with the press of a button. It is likely")), /*#__PURE__*/React.createElement("text", {
    id: "that_the_internet_and_the_phone_system_will_be",
    "data-name": "that the internet and the phone system will be",
    transform: "translate(9285.701 1371.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "that the internet and the phone system will be")), /*#__PURE__*/React.createElement("text", {
    id: "overwhelmed_as_a_disaster_intensifies_this_is_why_the",
    "data-name": "overwhelmed as a disaster intensifies, this is why the",
    transform: "translate(9285.701 1401.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "overwhelmed as a disaster intensifies, this is why the")), /*#__PURE__*/React.createElement("text", {
    id: "APP_owner_immediately_activates_the_plan_at_the_onset",
    "data-name": "APP owner immediately activates the plan at the onset",
    transform: "translate(9285.701 1431.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "APP owner immediately activates the plan at the onset")), /*#__PURE__*/React.createElement("text", {
    id: "of_the_disaster._All_members_will_know_where_to_meet",
    "data-name": "of the disaster. All members will know where to meet",
    transform: "translate(9285.701 1461.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of the disaster. All members will know where to meet")), /*#__PURE__*/React.createElement("text", {
    id: "based_on_the_PRE-RECORDED_message_instructions",
    "data-name": "based on the PRE-RECORDED message/instructions",
    transform: "translate(9285.701 1491.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "based on the PRE-RECORDED message/instructions")), /*#__PURE__*/React.createElement("text", {
    id: "that_was_sent_to_them.",
    "data-name": "that was sent to them.",
    transform: "translate(9285.701 1521.279)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "that was sent to them.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-14",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(9737.897 1566.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-3",
    x1: 315.5,
    transform: "translate(9751.367 1574.579) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-3",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(9759.867 1571.279) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "All_Social_Media_User",
    "data-name": "All Social Media User",
    transform: "translate(9781.353 1654.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "All Social Media User")), /*#__PURE__*/React.createElement("text", {
    id: "Names_and_Passwords",
    "data-name": "Names and Passwords",
    transform: "translate(9781.353 1686.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Names and Passwords")), /*#__PURE__*/React.createElement("text", {
    id: "so_the_account_can_be",
    "data-name": "so the account can be",
    transform: "translate(9781.353 1718.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "so the account can be")), /*#__PURE__*/React.createElement("text", {
    id: "shut_down_in_the_event",
    "data-name": "shut down in the event",
    transform: "translate(9781.353 1750.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "shut down in the event")), /*#__PURE__*/React.createElement("text", {
    id: "of_an_untimely_death.",
    "data-name": "of an untimely death.",
    transform: "translate(9781.353 1782.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of an untimely death.")), /*#__PURE__*/React.createElement("text", {
    id: "This_is_critical_as_it_is_rarely",
    "data-name": "This is critical as it is rarely",
    transform: "translate(9781.353 1822.029)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "This is critical as it is rarely")), /*#__PURE__*/React.createElement("text", {
    id: "thought_about_until_it_s_too",
    "data-name": "thought about until it\\u2019s too",
    transform: "translate(9781.353 1852.029)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "thought about until it\u2019s too")), /*#__PURE__*/React.createElement("text", {
    id: "late.",
    transform: "translate(9781.353 1882.029)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "late.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-15",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(9839.001 1565.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-4",
    x2: 274.8,
    transform: "translate(9852.531 1309) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-4",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(9861.031 1570.1) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Bank_Account_Numbers",
    "data-name": "Bank Account Numbers",
    transform: "translate(9882.164 1330.28)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Bank Account Numbers")), /*#__PURE__*/React.createElement("text", {
    id: "and_Access_Codes.",
    "data-name": "and Access Codes.",
    transform: "translate(9882.164 1362.28)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "and Access Codes.")), /*#__PURE__*/React.createElement("text", {
    id: "In_the_event_of_a_lost_or_stolen",
    "data-name": "In the event of a lost or stolen",
    transform: "translate(9882.164 1402.28)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "In the event of a lost or stolen")), /*#__PURE__*/React.createElement("text", {
    id: "purse_or_the_untimely_death_of_a",
    "data-name": "purse or the untimely death of a",
    transform: "translate(9882.164 1432.28)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "purse or the untimely death of a")), /*#__PURE__*/React.createElement("text", {
    id: "loved_one_quick_access_to_the",
    "data-name": "loved one; quick access to the",
    transform: "translate(9882.164 1462.28)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "loved one; quick access to the")), /*#__PURE__*/React.createElement("text", {
    id: "unknown_account_or_password",
    "data-name": "unknown account or password",
    transform: "translate(9882.164 1492.28)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "unknown account or password")), /*#__PURE__*/React.createElement("text", {
    id: "protected_accounts_is_a_must.",
    "data-name": "protected accounts is a must.",
    transform: "translate(9882.164 1522.28)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "protected accounts is a must.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-16",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(10100.7 1566.279)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-5",
    y1: 340.5,
    transform: "translate(10114.12 1574.529)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-5",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(10105.62 1571.229)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Location_of_Stocks_Bonds_",
    "data-name": "Location of Stocks, Bonds,",
    transform: "translate(10144.168 1654.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Location of Stocks, Bonds,")), /*#__PURE__*/React.createElement("text", {
    id: "Portfolios_Loan_Paper_Work_",
    "data-name": "Portfolios, Loan Paper Work,",
    transform: "translate(10144.168 1686.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Portfolios, Loan Paper Work,")), /*#__PURE__*/React.createElement("text", {
    id: "Insurance_Papers_etc.",
    "data-name": "Insurance Papers, etc.",
    transform: "translate(10144.168 1718.529)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Insurance Papers, etc.")), /*#__PURE__*/React.createElement("text", {
    id: "Fact:_Many_spouses_are_unaware_of_the",
    "data-name": "Fact: Many spouses are unaware of the",
    transform: "translate(10144.168 1759.779)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fact: Many spouses are unaware of the")), /*#__PURE__*/React.createElement("text", {
    id: "location_of_stocks_bonds_or_other",
    "data-name": "location of stocks, bonds, or other",
    transform: "translate(10144.168 1789.779)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "location of stocks, bonds, or other")), /*#__PURE__*/React.createElement("text", {
    id: "investment_portfolios_of_their_mate_and",
    "data-name": "investment portfolios of their mate, and",
    transform: "translate(10144.168 1819.779)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "investment portfolios of their mate, and")), /*#__PURE__*/React.createElement("text", {
    id: "therefore_sometimes_never_gain_access",
    "data-name": "therefore sometimes never gain access",
    transform: "translate(10144.168 1849.779)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "therefore sometimes never gain access")), /*#__PURE__*/React.createElement("text", {
    id: "to_these_accounts_after_the_death_of",
    "data-name": "to these accounts after the death of",
    transform: "translate(10144.168 1879.779)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "to these accounts after the death of")), /*#__PURE__*/React.createElement("text", {
    id: "their_spouse.",
    "data-name": "their spouse.",
    transform: "translate(10144.168 1909.779)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "their spouse.")), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_117-17",
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    transform: "translate(10223.5 1563.579)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_87-6",
    x2: 349.3,
    transform: "translate(10237.05 1233.029) rotate(90)",
    fill: "none",
    stroke: "#ff3535",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_118-6",
    cx: 8.5,
    cy: 8.5,
    r: 8.5,
    transform: "translate(10245.55 1568.529) rotate(90)",
    fill: "#ff3535"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Ability_to_record_the_purchase",
    "data-name": "Ability to record the purchase",
    transform: "translate(10266.299 1261.28)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Ability to record the purchase")), /*#__PURE__*/React.createElement("text", {
    id: "price_and_estimated",
    "data-name": "price and estimated",
    transform: "translate(10266.299 1293.28)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "price and estimated")), /*#__PURE__*/React.createElement("text", {
    id: "replacement_values_of_home",
    "data-name": "replacement values of home",
    transform: "translate(10266.299 1325.28)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "replacement values of home")), /*#__PURE__*/React.createElement("text", {
    id: "inventory_items_as_well_as",
    "data-name": "inventory items, as well as",
    transform: "translate(10266.299 1357.28)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "inventory items, as well as")), /*#__PURE__*/React.createElement("text", {
    id: "uploading_a_video_or_pictures",
    "data-name": "uploading a video or pictures",
    transform: "translate(10266.299 1389.28)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "uploading a video or pictures")), /*#__PURE__*/React.createElement("text", {
    id: "of_the_items.",
    "data-name": "of the items.",
    transform: "translate(10266.299 1421.28)",
    fill: "#ff3535",
    fontSize: 24,
    fontFamily: "Roboto",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "of the items.")), /*#__PURE__*/React.createElement("text", {
    id: "Take_the_time_to_ask_your_insurance",
    "data-name": "Take the time to ask your insurance",
    transform: "translate(10266.299 1467.28)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Take the time to ask your insurance")), /*#__PURE__*/React.createElement("text", {
    id: "agent_how_valuable_this_is_and_how",
    "data-name": "agent how valuable this is, and how",
    transform: "translate(10266.299 1497.28)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "agent how valuable this is, and how")), /*#__PURE__*/React.createElement("text", {
    id: "quickly_it_can_be_used_to_settle_a_claim.",
    "data-name": "quickly it can be used to settle a claim.",
    transform: "translate(10266.299 1527.28)",
    fontSize: 18,
    fontFamily: "Roboto"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "quickly it can be used to settle a claim.")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrfRoadmapLap);
export default __webpack_public_path__ + "static/media/MRF_roadmap-lap.2a4fd132f8ecb097c9b7512c7681fdfc.svg";
export { ForwardRef as ReactComponent };